const MAX_UITEXT_LENGTH = 10

export default (context) => {
  const { _ } = context

  let translation_flat = {} // JSON.parse(localStorage.translation_flat || '{}')
  let needs_review = {}

  window.localeSeed = () => {
    const els = document.documentElement.querySelectorAll('[data-i18n]')
    const translation = {}
    // const translation_flat = {}

    els.forEach(el => {
      const path = el.getAttribute('data-i18n')
      _.set(translation, path, el.innerText)
      if (!isNaN(parseInt(el.innerText))) return
      if (el.innerText.split(' ').length > MAX_UITEXT_LENGTH) {
        needs_review[path] = el.innerText
        return console.log('long text', path, el.innerText)
      }
      translation_flat[path] = el.innerText
    })
    // localStorage.translation_flat = JSON.stringify(translation_flat)

    console.log(`node scripts/gtranslate.js -t=${JSON.stringify(JSON.stringify(translation_flat))}`)
    return {
      translation,
      translation_flat,
      needs_review
    }
  }
}